import React, { useState } from 'react';

const BulkConfirmationModal = ({
  show,
  actionName,
  eligibleItems,
  ineligibleItems,
  requiresReason,
  onConfirm,
  onCancel,
}) => {
  const [reason, setReason] = useState('');
  const [showIneligible, setShowIneligible] = useState(false);

  if (!show) return null;

  const handleConfirm = () => {
    onConfirm(requiresReason ? reason : undefined);
    setReason('');
  };

  const handleCancel = () => {
    setReason('');
    onCancel();
  };

  const isConfirmDisabled = requiresReason && reason.trim() === '';

  return (
    <>
      <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm {actionName}</h5>
              <button type="button" className="btn-close" onClick={handleCancel}></button>
            </div>
            <div className="modal-body">
              <p>
                This will apply <strong>{actionName}</strong> to{' '}
                <strong>{eligibleItems.length}</strong> eligible{' '}
                {eligibleItems.length === 1 ? 'job' : 'jobs'}.
              </p>

              {ineligibleItems.length > 0 && (
                <div className="mb-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-link p-0 text-decoration-none"
                    onClick={() => setShowIneligible(!showIneligible)}
                  >
                    <i className={`bi bi-chevron-${showIneligible ? 'down' : 'right'} me-1`}></i>
                    {ineligibleItems.length} ineligible{' '}
                    {ineligibleItems.length === 1 ? 'job' : 'jobs'}
                  </button>

                  {showIneligible && (
                    <ul className="list-group list-group-flush mt-2">
                      {ineligibleItems.map((item, index) => (
                        <li key={index} className="list-group-item py-1 px-2 small">
                          <span className="text-muted">{item.job?.fileName || `Job ${index + 1}`}</span>
                          {' — '}
                          <span className="text-danger">{item.reason}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}

              {requiresReason && (
                <div className="mb-3">
                  <label htmlFor="bulk-reason-input" className="form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <input
                    id="bulk-reason-input"
                    type="text"
                    className="form-control"
                    placeholder="Enter reason..."
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleConfirm}
                disabled={isConfirmDisabled}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default BulkConfirmationModal;
